export default "__VITE_ASSET__BJsq7ziC__"